import get from "lodash/get";
import size from "lodash/size";
import head from "lodash/head";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Grid, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Box, LinearProgress, makeStyles } from "@material-ui/core";
import { showError, showSuccess } from "../actions/Error";
import { PhotographUploader } from "./form/PhotographUploader";
import { briefGalleryList } from "../v2_actions/brief_gallery";
import { navigateToFilteredGallery } from "../v2_actions/gallery";
import { albumListForEventTab } from "../v2_actions/customer_album"
import { basePhotographList } from "../v2_actions/customer_photograph";
import { customerFacialRecognition } from "../v2_actions/customer_facial_recognition";
import { formatSessionNameForURL } from "../v2_actions/nav"

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    fontSize: 15,
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: 12,
    },
  },
  facialRecognitionImage: {
    width: 47,
    height: 47,
  },
  bibNumberIllustration: {
    display: "grid",
    textAlign: "center",
    alignContent: "center",
    border: "dotted 1px #000",
  },
  indexingInProgressMessage: {
    textAlign: "center",
  },
  matchedFaceIdsText: {
    textAlign: "center",
  },
  photographWrapper: {
    bottom: 10,
    width: 180,
    height: 100,
    position: "relative",
    border: "dashed 1px #000",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  facialRecognitionText: {
    fontSize: 16,
    color: "#000",
    [theme.breakpoints.up("sm")]: {
      fontSize: 12,
    },
  },
  uploadSelfieButton: {
    height: 31,
    width: 189,
    "& p": {
      fontSize: 16,
      fontWeight: 600,
      textTransform: "capitalize",
      [theme.breakpoints.down("sm")]: {
        fontSize: 12,
      },
    },
    [theme.breakpoints.down("sm")]: {
      height: 28,
      width: 150,
    },
  },
  closeIcon: {
    color: "#000",
    cursor: "pointer",
    position: "absolute",
    fontSize: "20px !important",
    margin: "-5px 0px 0px 15px",
  },
}));

const Item = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: "blue",
}));

export default function AlbumFacialRecognition({
  albumNameForAPI,
  clearFiltersWasClicked,
  setClearFiltersWasClicked,
  setExpandActiveMobileTabFilter,
  setIsFacialRecognitionFilterActive,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const gallery = head(useSelector(() => briefGalleryList.getVisibleObjects()));
  const galleryId = get(gallery, "id");
  const albumId = useSelector(() => albumListForEventTab.getIdForAlbumName(albumNameForAPI));
  const sessionNameForUrl = gallery && formatSessionNameForURL(get(gallery, "session_name"));
  const dbId = get(gallery, "db_id");
  const [preview, setPreview] = useState();
  const [matchedFaceIds, setMatchedFaceIds] = useState([]);
  const [indexingInProgress, setIndexingInProgress] = useState(false);
  const [fileUploadsInProgress, setFileUploadsInProgress] = useState({});
  const [isPhotographUploading, setIsPhotographUploading] = useState(false);
  const [
    customerSelfieFileInfoPhotograph,
    setCustomerSelfieFileInfoPhotograph,
  ] = useState(null);

  useEffect(() => {
    if (clearFiltersWasClicked) clearFacialRecognition();
    setClearFiltersWasClicked(false);
  }, [clearFiltersWasClicked]);

  

  const onIndexCustomer = (file_info) => {
    setIsFacialRecognitionFilterActive(true);
    setIndexingInProgress(true);
    setCustomerSelfieFileInfoPhotograph(file_info);
    const on_done = (json) => {
      if (json.status === "success") {
        onSearchCustomer(json.face_token);
        showSuccess("Selfie Indexed");

        customerFacialRecognition.setCustomerFacialRecognitionFaceToken(
          "customer_face_token",
          get(json, "face_token"),
        );
      } else {
        showError("Failed", json.error_message);
        setIndexingInProgress(false);
      }
    };
    dispatch(
      customerFacialRecognition.indexForCustomer(get(file_info, "id")),
    ).then(on_done);
  };

  const clearFacialRecognition = () => {
    setPreview(null);
    setExpandActiveMobileTabFilter(false);
    setCustomerSelfieFileInfoPhotograph(null);
    dispatch(basePhotographList.clearListFilter());
    customerFacialRecognition.setCustomerFacialRecognitionFaceToken(null);
  };

  const onSearchCustomer = (customer_face_token) => {
    const on_done = (json) => {
      setExpandActiveMobileTabFilter(false);
      if (json.status === "success") {
        navigateToFilteredGallery(navigate, sessionNameForUrl, dbId, customer_face_token, albumId);
      } else {
        showError("Failed", json.error_message);
        setIndexingInProgress(false);
      };
    };
    dispatch(
      customerFacialRecognition.searchForCustomerWithScope(
        'album',
        albumId,
        customer_face_token,
      ),
    ).then(on_done);
  };

  const renderCustomerSelfieUploader = () => {
    return (
      <PhotographUploader
        maxFileLimit={1}
        preview={preview}
        gallery_id={galleryId}
        setPreview={setPreview}
        fileAnnotations={fileUploadsInProgress}
        disabled={customerSelfieFileInfoPhotograph}
        customButtonStyle={classes.uploadSelfieButton}
        clearFacialRecognition={clearFacialRecognition}
        setIsPhotographUploading={setIsPhotographUploading}
        onChange={(file_info) => onIndexCustomer(file_info)}
      />
    );
  };

  return (
    <div>
      <div>
        <div>
          <Stack direction={{ xs: "column", sm: "row" }}>
            <Stack
              direction="column"
              alignItems="center"
              justifyContent="center"
              sx={{ margin: "auto" }}
            >
              <Item>
                {renderCustomerSelfieUploader()}
                <Box m={1}>
                  {(isPhotographUploading || indexingInProgress) && (
                    <LinearProgress />
                  )}
                </Box>
              </Item>
            </Stack>
          </Stack>
        </div>
      </div>
    </div>
  );
}
